import React from "react";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Icon from "@mui/material/Icon";
import { motion } from "framer-motion";

const servicesData = [
  {
    color: "info",
    icon: "home",
    title: "Find a Home",
    description:
      "Discover the perfect rental or property to buy, tailored to your preferences in East Africa.",
  },
  {
    color: "info",
    icon: "directions_car",
    title: "Car Rental & Purchase",
    description:
      "Book or buy a car with professional drivers to ensure smooth travel during your stay.",
  },
  {
    color: "info",
    icon: "real_estate_agent",
    title: "Land & Plots",
    description: "Invest in the right plot or land with our guidance across East Africa.",
  },
  {
    color: "primary",
    icon: "cleaning_services",
    title: "Hire a Maid",
    description: "Find reliable, multilingual maids to make your stay comfortable and hassle-free.",
  },
  {
    color: "primary",
    icon: "support_agent",
    title: "Personal Assistance",
    description: "Need guidance? Get personalized help for all your essentials and services.",
  },
];

function ServicesSection() {
  return (
    <MKBox
      component="section"
      py={{ xs: 8, md: 12 }}
      px={{ xs: 2, md: 6 }}
      sx={{
        background: "linear-gradient(135deg, #fdfdfdff 0%, #ffffffff 60%)",
      }}
    >
      <MKTypography variant="h3" fontWeight="bold" color="#003060" textAlign="center" mb={6}>
        Our Services
      </MKTypography>

      <Grid container spacing={4} justifyContent="center">
        {servicesData.map((card, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: idx * 0.2 }}
            >
              <MKBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                textAlign="center"
                p={4}
                height="100%"
                sx={{
                  background: "#003060",
                  borderRadius: "2rem",
                  boxShadow: "0 8px 30px rgba(0,0,0,0.25), 0 0 20px rgba(255,255,255,0.05)",
                  transition: "all 0.4s ease",
                  "&:hover": {
                    transform: "translateY(-15px)",
                    boxShadow: "0 12px 35px rgba(0,0,0,0.35), 0 0 30px rgba(63,132,255,0.25)",
                  },
                }}
              >
                {/* Icon Circle */}
                <MKBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mb={2}
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: "#fff", // white background
                    color:
                      card.color === "info"
                        ? "#17a2b8"
                        : card.color === "primary"
                        ? "#0d6efd"
                        : card.color === "success"
                        ? "#28a745"
                        : card.color === "danger"
                        ? "#dc3545"
                        : "#6c757d", // default gray
                    fontSize: "2rem",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.25)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <Icon>{card.icon}</Icon>
                </MKBox>

                {/* Title */}
                <MKTypography variant="h5" fontWeight="bold" mb={1.5} sx={{ color: "#fff" }}>
                  {card.title}
                </MKTypography>

                {/* Description */}
                <MKTypography
                  variant="body2"
                  color="white"
                  mb={3}
                  sx={{ opacity: 0.85, minHeight: "70px" }}
                >
                  {card.description}
                </MKTypography>

                {/* Modern Button */}
                {/* <MKButton
                  variant="gradient"
                  color={card.color}
                  size="small"
                  sx={{
                    borderRadius: "1.5rem",
                    px: 4,
                    py: 1.2,
                    textTransform: "capitalize",
                    fontWeight: "medium",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      boxShadow:
                        "0 8px 20px rgba(0,0,0,0.25), 0 0 10px rgba(255,255,255,0.1)",
                    },
                  }}
                >
                  Learn More
                </MKButton> */}
              </MKBox>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </MKBox>
  );
}

export default ServicesSection;
